import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
// Admin pages
import Dashboard from "@/pages/Dashboard.vue"
import Orders from "@/pages/Orders.vue";
import Clients from "@/pages/Clients.vue";
import Bonuses from "@/pages/Bonuses.vue";
import Promocodes from "@/pages/Promocodes.vue";
import Deliveries from "@/pages/Deliveries.vue";
import Shops from "@/pages/Shops.vue";
import Types from "@/pages/Types.vue";
import Payments from "@/pages/Payments.vue";
import Pages from "@/pages/Pages.vue";
import Banners from "@/pages/Banners.vue";
import Products from "@/pages/Products.vue";
import Users from "@/pages/Users.vue";
import Quit from "@/pages/Quit.vue";
import Partners from "@/pages/Partners.vue";
import Scorings from "@/pages/Scorings.vue";

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        children: [
            {
                path: "dashboard",
                name: "Статистика",
                component: Dashboard
            },
            {
                path: "orders",
                name: "Заказы",
                component: Orders
            },
            {
                path: "clients",
                name: "Клиенты",
                component: Clients
            },
            {
                path: "bonuses",
                name: "Клиенты",
                component: Bonuses
            },
            {
                path: "promocodes",
                name: "Промокоды",
                component: Promocodes
            },
            {
                path: "deliveries",
                name: "Доставка",
                component: Deliveries
            },
            {
                path: "partners",
                name: "Партнеры",
                component: Partners
            },
            {
                path: "scorings",
                name: "Скоринги",
                component: Scorings
            },
            {
                path: "shops",
                name: "Магазины",
                component: Shops
            },
            {
                path: "types",
                name: "Виды покупок",
                component: Types
            },
            {
                path: "payments",
                name: "Платежные системы",
                component: Payments
            },
            {
                path: "pages",
                name: "Страницы",
                component: Pages
            },
            {
                path: "slides",
                name: "Слайдеры",
                component: Banners
            },
            {
                path: "products",
                name: "Продукция",
                component: Products
            },
            {
                path: "users",
                name: "Пользователи",
                component: Users
            },
            {
                path: "quit",
                name: "Выход",
                component: Quit
            },
        ]
    },
    { path: "*", component: NotFound }
];

export default routes;
